import styled from 'styled-components';

interface IServiceProps {
    img?: string,
}
export const Service = styled.div<IServiceProps>`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: start;
    min-height: 180px;
    margin-bottom: 20px;
    padding-top: 14px;
    padding-bottom: 18px;
    padding-left: 20px;
    color: #000000;
    background-image: url(${props => props.img ? props.img : null});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center top;
    @media (min-width: 620px) {
        width: 580px;
}
@media (min-width: 980px) {
    width: 470px;
    min-height: 250px;
}
`;

export const Title = styled.p`
    width: 150px;
    margin: 0;
    margin-bottom: 12px;
    font-size: 20px;
    font-weight: 400;
    @media (min-width: 980px) {
        width: 250px;
        font-size: 28px;
}
`;

export const Description = styled(Title)`
    width: 165px;
    font-size: 14px;
    line-height: 1.6;
    @media (min-width: 980px) {
        width: 200px;
}
`;

export const Link = styled.a`
    display: block;
    width: 160px;
    font-size: 14px;
    color: #007ae5;
    text-decoration: underline;
    &:hover {
        color: #ff2323;
        cursor: pointer;
}
@media (min-width: 980px) {
    width: 170px;
}
  `;
